// src/agreement/index.ts
var AgreementItemCode = /* @__PURE__ */ ((AgreementItemCode2) => {
  AgreementItemCode2["MA1"] = "MA1";
  AgreementItemCode2["MB1"] = "MB1";
  AgreementItemCode2["OA1"] = "OA1";
  AgreementItemCode2["OB1"] = "OB1";
  AgreementItemCode2["OB2"] = "OB2";
  AgreementItemCode2["OC1"] = "OC1";
  AgreementItemCode2["TA1"] = "TA1";
  AgreementItemCode2["TA2"] = "TA2";
  return AgreementItemCode2;
})(AgreementItemCode || {});

export { AgreementItemCode };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map